define([], function () {
    'use strict';

    return {
        serialize: ({documentServicesModel, rendererModel}) => ({
            site: Object.assign({},
                {
                    siteInfo: rendererModel.siteInfo,
                    version: {version: documentServicesModel.version, revision: documentServicesModel.revision}
                }, 
                rendererModel.multilingualInfo ? {multilingualInfo: rendererModel.multilingualInfo} : {})
        }
        ),
        deserialize: payload => ({
            documentServicesModel: Object.assign(payload.site.version),
            rendererModel: Object.assign({
                siteInfo: payload.site.siteInfo},
            payload.site.multilingualInfo ? {multilingualInfo: payload.site.multilingualInfo} : {})
        }),
        getEncryptedPaths: () => ['site.siteInfo', 'site.revision', 'site.version', 'site.dataFromMasterPage', 'site.multilingualInfo']
    };
});
